import { useCallback, useEffect, useState } from 'react'
import { useAuthNobia } from '../../components/azure/AuthContext'
import settings from '../../components/settings'

const LocalStorageKey = 'create-online-meeting'

export const useOnlineMeeting = ({ appointmentId }) => {
  const { token, login } = useAuthNobia()
  const [meeting, setMeeting] = useState()
  const [loading, setLoading] = useState(false)
  const [error, setError] = useState()

  const getMeeting = useCallback(async () => {
    setLoading(true)
    const response = await fetch(
      `${settings.badaAppointmentApiUrl}/appointment/${appointmentId}/online-meeting?brand=${settings.brand}`
    )
    const data = response.status === 200 ? await response.json() : null
    const err = !response.ok && (await response.text())
    const success = response.ok
    if (success) {
      setMeeting(data || {})
      setError(undefined)
    } else {
      setMeeting({})
      setError(err)
    }
    setLoading(false)
    return { success, data, error: err }
  }, [appointmentId])

  const create = useCallback(async () => {
    setLoading(true)
    const response = await fetch(
      `${settings.badaAppointmentApiUrl}/appointment/${appointmentId}/online-meeting?brand=${settings.brand}`,
      {
        method: 'POST',
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    )
    const data = response.ok && (await response.json())
    const err = !response.ok && (await response.text())
    const success = response.ok
    if (success) {
      setMeeting(data)
      setError(undefined)
    } else {
      setMeeting({})
      setError(err)
    }
    setLoading(false)
    return { success, data, error: err }
  }, [token, appointmentId])

  const createMeeting = useCallback(() => {
    if (token) {
      return create()
    }
    window.localStorage.setItem(LocalStorageKey, window.location.href)
    setLoading(true)
    return login()
      .catch((e) => ({
        error: e,
      }))
      .finally(() => {
        setLoading()
      })
  }, [token, login, create])

  const deleteMeeting = useCallback(async () => {
    setLoading(true)
    const response = await fetch(
      `${settings.badaAppointmentApiUrl}/appointment/${appointmentId}/online-meeting?brand=${settings.brand}`,
      {
        method: 'DELETE',
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    )
    const err = !response.ok && (await response.text())
    const success = response.ok
    if (success) {
      setMeeting({})
    }
    setLoading(false)
    return { success, error: err }
  }, [token, appointmentId])

  useEffect(() => {
    const meetingHref = window.localStorage.getItem(LocalStorageKey)
    if (meetingHref && token) {
      if (meetingHref === window.location.href) {
        window.localStorage.removeItem(LocalStorageKey)
        createMeeting()
      }
    } else if (!meeting && !loading) {
      getMeeting()
    }
  }, [createMeeting, getMeeting, token, meeting, loading])

  return { createMeeting, deleteMeeting, meeting, error, loading }
}
